{
  "titles": {
    "menu": "Gebruikers",
    "table": "Gebruikers",
    "create": "Gebruiker aanmaken",
    "update": "Gebruiker wijzigen",
    "settings": "Bevoegdheden",
    "contactInformation": "Contactinformatie"
  },
  "fields": {
    "labels": {
      "gender": "Geslacht",
      "name": "Roepnaam",
      "displayName": "Naam",
      "fullName": "Volledige naam",
      "lastName": "Achternaam",
      "email": "E-mailadres",
      "phone": "Telefoonnummer",
      "isSigningAuthority": "Is tekenbevoegd",
      "canRequestLoans": "Mag leningen aanvragen",
      "hasAccessToPortal": "Heeft toegang tot de app",
      "firstNames": "Volledige voornamen",
      "dateOfBirth": "Geboortedatum",
      "isContactPerson": "Contactpersoon"
    },
    "descriptions": {
      "isSigningAuthority": "Documenten ondertekenen namens het bedrijf",
      "canRequestLoans": "Nieuwe leningen indienen namens het bedrijf",
      "hasAccessToPortal": "Inloggen bij Mijn DebitRoom"
    },
    "hints": {
    }
  },
  "headers": {
    "labels": {
      "name": "Naam",
      "email": "E-mail",
      "phone": "Telefoon",
      "isSigningAuthority": "Tekenbevoegd",
      "hasAccessToPortal": "Toegang tot app"
    }
  },
  "messages": {
    "createSuccess": "Gebruiker aangemaakt",
    "updateSuccess": "Gebruiker is opgeslagen",
    "checkedAtBy": "Gecontroleerd op {date} door {name}"
  },
  "actions": {
    "create": "Gebruiker aanmaken",
    "createAnother": "Nog een gebruiker aanmaken",
    "update": "Gebruiker aanpassen",
    "search": "Zoek een account"
  }
}
